import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';

const ClientFilterContext = createContext({
  currentClient: null,
  setCurrentClient: val => val,
  currentEstablishment: null,
  setCurrentEstablishment: val => val,
  currentArea: null,
  setCurrentArea: val => val,
  currentClientEntity: null,
  setCurrentClientEntity: val => val,
  currentEstablishmentEntity: null,
  setCurrentEstablishmentEntity: val => val,
  currentAreaEntity: null,
  setCurrentAreaEntity: val => val,
  currentService: null,
  setCurrentService: val => val,
  valueGoal: null,
  setValueGoal: val => val,
  servicesTemplatesGoal: null,
  setServicesTemplatesGoal: val => val,
});

const useClientFilter = () => {
  const context = useContext(ClientFilterContext);
  if (context === undefined) {
    throw new Error('useClientFilter must be used within a AuditDataProvider');
  }

  return context;
};

const ClientFilterProvider = ({ ...props }) => {

  const [currentClient, setCurrentClient] = useState({});
  const [currentEstablishment, setCurrentEstablishment] = useState({});
  const [currentArea, setCurrentArea] = useState({});
  const [currentClientEntity, setCurrentClientEntity] = useState({});
  const [currentEstablishmentEntity, setCurrentEstablishmentEntity] = useState({});
  const [currentAreaEntity, setCurrentAreaEntity] = useState({});
  const [currentService, setCurrentService] = useState('');
  const [valueGoal, setValueGoal] = useState(0);
  const [servicesTemplatesGoal, setServicesTemplatesGoal] = useState([]);
  
  return (
    <ClientFilterContext.Provider
      value={{
        currentClient ,
        setCurrentClient,
        currentEstablishment,
        setCurrentEstablishment,
        currentArea,
        setCurrentArea,
        currentClientEntity,
        setCurrentClientEntity,
        currentEstablishmentEntity,
        setCurrentEstablishmentEntity,
        currentAreaEntity,
        setCurrentAreaEntity,
        currentService,
        setCurrentService,
        valueGoal,
        setValueGoal,
        servicesTemplatesGoal,
        setServicesTemplatesGoal
      }}
      {...props}
    />
  );
};

ClientFilterProvider.propTypes = {
  defaultFilter: PropTypes.object,
};

export { useClientFilter, ClientFilterProvider };

